"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.image = exports.text = exports.root = void 0;

const root = ({
  cssProps
}) => {
  const {
    variant
  } = cssProps;
  return {
    width: variant === 'half' ? 428 : 277
  };
};

exports.root = root;

const text = ({
  cssProps
}) => {
  const {
    width = 'inline'
  } = cssProps;
  return {
    width: width === 'inline' ? '148px' : '100%',
    wordBreak: 'break-word'
  };
};

exports.text = text;

const image = () => ({
  width: 82,
  height: 82
});

exports.image = image;
//# sourceMappingURL=PerformanceCard.style.js.map